/* ─────────────────────────────────────────────────────────────
   NAVIGATION CONFIG — Single source of truth for nav links.
   The Navbar reads from here so links are never hardcoded
   directly into the component.
   ───────────────────────────────────────────────────────────── */

export const navLinks = [
  // isRoute: true       → uses React Router <Link to="...">  (no page reload)
  // isRoute: false      → uses plain <a href="...">  (can be an anchor or external)
  // authRequired: true  → only shown to logged-in users
  // hideWhenAuthed: true → hidden once logged in (marketing-only links)
  { label: 'Features',    href: '/#features',  isRoute: false, authRequired: false, hideWhenAuthed: true  },
  { label: 'For Clubs',   href: '/for-clubs',   isRoute: true,  authRequired: false, hideWhenAuthed: true  },
  { label: 'Pricing',     href: '/#pricing',    isRoute: false, authRequired: false, hideWhenAuthed: true, icon: '$' },
  { label: 'Leaderboard', href: '/leaderboard', isRoute: true,  authRequired: true,  hideWhenAuthed: false, icon: 'trophy' },
];
